import { CLEAR_GLOBAL_ERROR } from '../types/auth';
import { NAVIGATE_TO_SIGNUP, UIState } from '../types/uiTypes';

const initialState: UIState = { redirectTo: '' };

export function uiReducer(state = initialState, action: any): UIState {
  switch (action.type) {
    case NAVIGATE_TO_SIGNUP: {
      return { ...state, redirectTo: '/investor-signup' };
    }
    case CLEAR_GLOBAL_ERROR:
      return { ...state, redirectTo: '' };
    default:
      return state;
  }
}
